module.exports = __webpack_public_path__ + "static/manganese-ore-f9195eac4829be46ea74d8a822e6e494.png";